import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const textColor = '#393939';
const primaryBlue = '#05164D';
const borderColor = primaryBlue;

const cellProperties = {
  padding: 4,
  paddingLeft: 4,
  fontSize: 8,
  color: textColor,
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoRegular',
  borderRightColor: borderColor,
  borderRightWidth: 1,
  alignSelf: 'stretch', 
};
const headProperties = {
  paddingRight: 5,
  paddingLeft: 5,
  fontSize: 8,
  color: 'white',
  textTransform: 'uppercase',
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoMedium',
};

const styles = StyleSheet.create({
  headerContainer: { marginTop: 24 },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
    marginBottom: 20,
  },
  container: {
    flexDirection: 'row',
    padding: '4px 2px',
    backgroundColor: primaryBlue,
    color: 'white',
    alignItems: 'center',
    flexGrow: 1,
  },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
  },
  altRow: { backgroundColor: '#f5f5f5', },
  header10: {
    ...headProperties,
    width: '10%',
  },
  cell10: {
    ...cellProperties,
    width: '10%',
  },
  header20: {
    ...headProperties,
    width: '20%',
  },
  cell20: {
    ...cellProperties,
    width: '20%',
  },
  noDataRow: {
    fontSize: 9,
    width: '100%',
    textAlign: 'center',
    padding: 4,
    color: textColor,
    fontFamily: 'NunitoRegular',
  },
  noBorderRight: { borderRight: 'none', },
  wrapSPL: { flexWrap: 'wrap', },
});

const Awbs = (props) => {
  const { manifestData } = props;

  return (
    <View style={styles.headerContainer}>
      <Text style={styles.title}>No Scan List</Text>
        
      <View style={styles.tableContainer}>
        <View style={styles.container}>
          <Text style={styles.header20}>Awb #</Text>
          <Text style={[styles.header10, { textAlign: 'center' }]}>Org-Dest</Text>
          <Text style={styles.header10}>Pcs</Text>
          <Text style={styles.header20}>Remark</Text>
          <Text style={styles.header20}>Prod</Text>
          <Text style={styles.header20}>SPL Code</Text>
        </View>
        {
          manifestData && manifestData?.length > 0 ?
            manifestData && manifestData?.map((uld) => {
              return uld?.flight_awbs?.map((awb, i) => {
                if (!awb?.awbId) {
                  return (
                    <View style={[
                      styles.tableRow,
                      i % 2 === 1 && styles.altRow // Apply altRow to odd rows
                    ]} key={awb.id}>
                      <View style={styles.cell20}><Text>{awb.awb_no}</Text></View>
                      <View style={[styles.cell10, { textAlign: 'center' }]}><Text>{awb.org + '-' + awb.dest}</Text></View>
                      <View style={styles.cell10}><Text>{awb.pcs}</Text></View>
                      <View style={styles.cell20}><Text>{awb.remark}</Text></View>
                      <View style={styles.cell20}><Text>{awb?.products?.length > 0 ? awb?.products?.map((item) => item.name).join(', ')
                        : (awb?.spl_code && awb?.products?.length == 0 && awb.prod_conflict ? 'CONFLICT'
                          : awb.products?.length == 0 && !awb.prod_conflict && 'GENERAL'
                        )}</Text>
                      </View>
                      <View style={[styles.cell20, styles.wrapSPL]}>
                        <Text>{awb?.spl_code ? awb?.spl_code.length > 0 && awb?.spl_code.split(',').join(', ') : '-'}</Text>
                      </View>
                    </View>);
                }
              });
            })
            : <View style={styles.noDataRow}>
              <Text>No Data</Text>
            </View>
        }
      </View>
    </View>
    
  );
};
  
export default Awbs;